import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Campaigns } from 'src/app/interfaces/CampaignsData';
import { MisCampaniasService } from 'src/app/service/misCampanias.service';

@Component({
  selector: 'app-mis-campanias',
  templateUrl: './mis-campanias.component.html',
  styleUrls: ['./mis-campanias.component.scss']
})
export class MisCampaniasComponent implements OnInit{

  deviceUrl: string = '';
  deviceName: string = '';

  campaigns: Campaigns[] = [];

  constructor(private route: ActivatedRoute, private campaignService: MisCampaniasService, private router: Router, private translate: TranslateService) { 
    // Establecer idiomas disponibles y el idioma por defecto
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('es');
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['deviceUrl'];
      const nombre = params['deviceName'] ; 
      if(nombre){
        this.deviceName = nombre;
      }
      if (token) {
        this.deviceUrl = token;
        this.getAllCampaigns(token);
      } else {
      }
    });
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  getAllCampaigns(token: string): void {
    this.campaignService.getAllCampaigns(token)
      .subscribe(campaigns => {
        this.campaigns = campaigns;
      });
  }

  regresar(deviceUrl: string, deviceName: string){
    this.router.navigate(['/campaigns'], { queryParams: { deviceUrl: this.deviceUrl, deviceName: this.deviceName },
    queryParamsHandling: 'merge' });
  }

  detalles(id: string, deviceUrl: string, deviceName: string){
    this.router.navigate(['/campaign-detail', id], {queryParams: {deviceUrl: this.deviceUrl, deviceName: this.deviceName},
    queryParamsHandling: 'merge'})
  }
}
